<template>
  <span>
    <span v-if="status == ReportStatus.WaitingSurvey" class="text-warning">Waiting for Patient's Survey</span>
    <span v-if="status == ReportStatus.WaitingReview" class="text-warning">Preparing Labwork Order</span>
    <span v-if="status == ReportStatus.WaitingResults || status == ReportStatus.FinalProcessing" class="text-warning">Waiting for Lab Result</span>
    <span v-if="status == ReportStatus.Cancelled" class="text-danger">Cancelled</span>
    <span v-if="status == ReportStatus.Completed" class="text-success">Completed</span>
    <span v-if="status == ReportStatus.OrderLabsFirst" class="text-warning">Order Labs First</span>
    <span v-if="status == ReportStatus.OrderOnHold" class="text-warning">Order On Hold</span>
    <span v-if="status == ReportStatus.LabsWaitingSurvey" class="text-warning">Waiting for Patient's Survey</span>
  </span>
</template>

<script>
  import ReportStatus from 'enums/report-status';

  export default {
    props: {
      status: Number
    },

    data() {
      return {
        ReportStatus
      }
    }
  };
</script>